import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { toast } from 'sonner';
import { Mail, Send, CheckCircle } from 'lucide-react';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    // Simulate subscription
    await new Promise(resolve => setTimeout(resolve, 1000));
    setSubscribed(true);
    setLoading(false);
    toast.success('¡Gracias por suscribirte!');
  };

  if (subscribed) {
    return (
      <div className="flex items-center justify-center gap-3 text-green-500">
        <CheckCircle className="w-5 h-5" />
        <span className="font-medium">¡Ya estás suscrito!</span>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
      <div className="relative flex-1">
        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
        <Input
          type="email"
          placeholder="Tu correo electrónico"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="pl-10 h-12 bg-white dark:bg-card"
          required
          data-testid="newsletter-email"
        />
      </div>
      <Button
        type="submit"
        className="btn-primary h-12 px-6"
        disabled={loading}
        data-testid="newsletter-submit"
      >
        {loading ? (
          'Enviando...'
        ) : (
          <>
            Suscribirse
            <Send className="w-4 h-4 ml-2" />
          </>
        )}
      </Button>
    </form>
  );
};

export default Newsletter;
